// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RefuseBonusModal_wrapper__wUFOT","buttons":"RefuseBonusModal_buttons__zSglW"};